import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from '@pages/about/about.component';
import { CommercialComponent } from '@pages/commercial/commercial.component';
import { ContactComponent } from '@pages/contact/contact.component';
import { ForgotPasswordComponent } from '@pages/forgot-password/forgot-password.component';
import { HoldingsComponent } from '@pages/holdings/holdings.component';
import { HomeComponent } from '@pages/home/home.component';
import { HostingComponent } from '@pages/hosting/hosting.component';
import { LoginComponent } from '@pages/login/login.component';
import { PartnershipsComponent } from '@pages/partnerships/partnerships.component';
import { PricingComponent } from '@pages/pricing/pricing.component';
import { RegisterComponent } from '@pages/register/register.component';
import { RetailComponent } from '@pages/retail/retail.component';
import { TransportationComponent } from '@pages/transportation/transportation.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'commercial', component: CommercialComponent },
  { path: 'transportation', component: TransportationComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'hosting', component: HostingComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'retail', component: RetailComponent },
  { path: 'holdings', component: HoldingsComponent },
  { path: 'partnerships', component: PartnershipsComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
